import { createFileRoute } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { organizationQueries } from '@/features/organizations/queries';
import { OrgBillingTab } from '@/features/billing-addresses/components/org-billing-tab/OrgBillingTab';
import { OrgBillingTabSkeleton } from '@/common/components/loading-skeleton/OrgBillingTabSkeleton';

export const Route = createFileRoute('/_authenticated/organizations/$organizationId/billing')({
  component: RouteComponent,
  pendingComponent: OrgBillingTabSkeleton,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  const { data: org } = useSuspenseQuery(organizationQueries.detail(organizationId));
  if (!org) return null;
  return <OrgBillingTab org={org} orgId={organizationId} />;
}
